import { makeStyles } from "@material-ui/core";

/**
 * This file contains all the styles used to override material-ui components which are being used within a component.
 */

const useStyles = makeStyles({
  listContainerItem: {
    height: "250px !important",
    paddingBottom: "0 !important",
    textAlign: "center",
  },
});

export default useStyles;
